<template>
    <layout-main :banner="banner" subtitle="设备能效管理系统">
        <template v-slot:content>
            <p class="text">通过能效监测设备，可持续监测设备使用情况，以提高院内设备使用效率，利用先进的数据分析、自动控制等技术手段，监测设备的功率、能量消耗、负载等参数，通过实时控制和优化操作，降低能源消耗，提高设备的效率和生产率，为医院设备采购和使用提供科学依据。</p>
            <img src="@/assets/device/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 24小时实时监测设备使用情况</p>
            <p class="text weight">· 数据可直接对接院内系统</p>
            <p class="text weight">· 异常情况及时发出告警信息</p>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/device/banner.png'
export default {
    components: {
        layoutMain,
        
    },
    data () {
        return {
            banner: banner
        }
    }
}
</script>
<style lang="scss" scoped>
.weight{
    font-weight: 600;
    line-height: 3 !important;
}
.title{ 
    text-indent: 1.5em;
    font-size: 25px;
    text-align: left;
    margin: 20px 0 10px;
}
.text{
    line-height: 2;
}
.image1{
    width: 100%;
    margin: 50px 0;
}
</style>
